document.addEventListener('DOMContentLoaded', function () {
  function announce(message) {
    var live = document.getElementById('a11y-status');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 50);
  }

  /* Mobile menu — focus trap, Escape to close, aria-expanded, focus restore */
  var burger = document.querySelector('[data-mobile-menu-open]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');
  var menu = document.querySelector('[data-mobile-menu]');

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')
    );
  }

  function openMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var focusables = getFocusable(menu);
    if (focusables.length) focusables[0].focus();
  }

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (burger) burger.focus();
  }

  if (burger && menu) {
    burger.setAttribute('aria-expanded', 'false');
    burger.addEventListener('click', openMenu);
  }
  if (closeBtn && menu) {
    closeBtn.addEventListener('click', closeMenu);
  }
  if (menu) {
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMenu();
        return;
      }
      if (e.key === 'Tab') {
        var focusables = getFocusable(menu);
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  /* Transparent header over a photo hero, solid again once scrolled past it */
  if (document.documentElement.classList.contains('theme--photo-hero')) {
    var siteHeader = document.querySelector('.site-header');
    var heroPhoto = document.querySelector('.hero--photo');
    if (siteHeader && heroPhoto) {
      var threshold = Math.max(heroPhoto.offsetHeight - siteHeader.offsetHeight - 40, 80);
      var syncHeader = function () {
        siteHeader.classList.toggle('is-scrolled', window.scrollY > threshold);
      };
      syncHeader();
      window.addEventListener('scroll', syncHeader, { passive: true });
      window.addEventListener('resize', function () {
        threshold = Math.max(heroPhoto.offsetHeight - siteHeader.offsetHeight - 40, 80);
        syncHeader();
      });
    }
  }

  /* Header search toggle */
  var searchOpenBtn = document.querySelector('[data-search-open]');
  var searchPanel = document.querySelector('[data-header-search]');
  if (searchOpenBtn && searchPanel) {
    searchOpenBtn.addEventListener('click', function () {
      var willOpen = searchPanel.hidden;
      searchPanel.hidden = !willOpen;
      searchOpenBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-quantity-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-quantity-minus]');
    var plus = wrapper.querySelector('[data-quantity-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* Product gallery thumbnails (accessible buttons, not bare clickable images) */
  document.querySelectorAll('[data-product-thumbs]').forEach(function (thumbs) {
    var main = document.querySelector('[data-product-main-image]');
    thumbs.querySelectorAll('button').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.querySelectorAll('button').forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
        thumb.setAttribute('aria-pressed', 'true');
        if (main && thumb.dataset.fullSrc) main.src = thumb.dataset.fullSrc;
      });
    });
  });

  /* Fulfillment method (delivery vs market pickup) on the cart page */
  var fulfillmentRadios = document.querySelectorAll('[data-fulfillment-method]');
  var pickupDetail = document.querySelector('[data-pickup-detail]');
  function syncFulfillment() {
    var selected = document.querySelector('[data-fulfillment-method]:checked');
    if (pickupDetail) pickupDetail.hidden = !selected || selected.value !== 'pickup';
  }
  if (fulfillmentRadios.length) {
    fulfillmentRadios.forEach(function (r) { r.addEventListener('change', syncFulfillment); });
    syncFulfillment();
  }

  /* Add to cart (AJAX), with real error handling and an accessible status message */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var labelEl = submitBtn ? submitBtn.querySelector('[data-add-label]') : null;
      var formData = new FormData(form);

      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
        if (labelEl) labelEl.dataset.originalText = labelEl.dataset.originalText || labelEl.textContent;
        if (labelEl) labelEl.textContent = '...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = (result.data && result.data.description) || 'Ce produit n\'est plus disponible dans la quantité demandée.';
            throw new Error(message);
          }
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.removeAttribute('aria-busy');
          }
          if (labelEl) {
            labelEl.textContent = 'Ajouté ✓';
            setTimeout(function () { labelEl.textContent = labelEl.dataset.originalText; }, 1500);
          }
          announce('Produit ajouté au panier. Panier : ' + cart.item_count + (cart.item_count > 1 ? ' articles.' : ' article.'));
        })
        .catch(function (err) {
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.removeAttribute('aria-busy');
          }
          if (labelEl) labelEl.textContent = labelEl.dataset.originalText;
          announce(err.message || 'Impossible d\'ajouter ce produit au panier pour le moment.');
        });
    });
  });

  /* Cart line quantity change -> update cart */
  document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.dataset.cartLineQty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('[data-cart-line-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.cartLineRemove;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });
});
